// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"7d2427b1","690":"167bf634","997":"96c1b229"}[chunkId] + ".chunk.js";
};